import React from 'react';
import Seo from '@/components/seo';
import { Col, Container, Row, } from 'react-bootstrap';
import { FaClock, FaShieldHalved } from 'react-icons/fa6';
import ReportRescue from '@/components/site/report-rescue';

function ReportAccess() {
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://aboutcar.com.br/'
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Acesse seu Relatório',
        item: 'https://aboutcar.com.br/acesse-seu-relatorio'
      }
    ]
  };

  return (
    <>
      <Seo
        title="Acesse seu Relatório de Consulta Veicular | AboutCar"
        description="Resgate e acesse seu relatório de consulta veicular por placa a qualquer momento na AboutCar. Informe seus dados e visualize seu laudo completo."
        keywords="resgatar relatorio consulta, acessar laudo veicular, consulta placa relatorio, buscar consulta efetuada"
        schema={breadcrumbSchema}
      />

      {/* Hero Section */}
      <section className="bg-light-subtle border-bottom py-5">
        <Container className="py-2">
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <span className="badge bg-primary text-white rounded-pill px-3 py-1 text-uppercase fw-bold mb-3 fs-7">AboutCar + Relatório</span>
              <h1 className="display-4 fw-extrabold text-dark mb-3">
                Acesse seu Relatório <span className="text-primary">agora mesmo</span>
              </h1>
              <p className="lead text-secondary mb-4">
                Simples, rápido e 100% online. Recupere o laudo completo da sua consulta veicular a qualquer momento sem complicações.
              </p>

              <Row className="g-3">
                <Col sm={6}>
                  <div className="p-3 bg-white rounded-4 shadow-sm border border-light-subtle d-flex align-items-center gap-3">
                    <div className="bg-primary-subtle text-primary p-2 rounded-3">
                      <FaClock className="fs-4" />
                    </div>
                    <div>
                      <span className="d-block text-muted small fw-semibold">Histórico Garantido</span>
                      <strong className="text-dark small">Sempre Disponível</strong>
                    </div>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="p-3 bg-white rounded-4 shadow-sm border border-light-subtle d-flex align-items-center gap-3">
                    <div className="bg-success-subtle text-success p-2 rounded-3">
                      <FaShieldHalved className="fs-4" />
                    </div>
                    <div>
                      <span className="d-block text-muted small fw-semibold">Segurança Total</span>
                      <strong className="text-dark small">Acesso Criptografado</strong>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>

            <Col lg={5} className="text-center">
              <img src="/assets/images/insurance-quote.svg" className="img-fluid max-h-350" border="0" alt="Acesse seu Relatório" loading="lazy" />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Form Section */}
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col lg={10} xl={9}>
            <ReportRescue />
          </Col>
        </Row>
      </Container>
    </>
  );
}

ReportAccess.enableMessages = true;
export default ReportAccess;
